module.exports = __webpack_public_path__ + "/login_ui/img/uy-2471ee7abb1ca0da05c7aab4a9b8e5cd.svg";